// extracted by mini-css-extract-plugin
export default {"container":"BeneficiaryList_container__euYir"};